import paper from '@turbowarp/paper';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import bindAll from 'lodash.bindall';
import Modes from '../lib/modes';

import { changeMode } from '../reducers/modes';
import { clearHoveredItem, setHoveredItem } from '../reducers/hover';
import { clearSelectedItems, setSelectedItems } from '../reducers/selected-items';
import { setCursor } from '../reducers/cursor';

import { getSelectedLeafItems } from '../helper/selection';
import SelectTool from '../helper/selection-tools/select-tool';
import SelectModeComponent from '../components/select-mode/select-mode.jsx';

class SelectMode extends React.Component {
  constructor(props) {
    super(props);
    bindAll(this, ['activateTool', 'deactivateTool']);
  }
  componentDidMount() {
    if (this.props.isSelectModeActive) {
      this.activateTool(this.props);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.tool && nextProps.hoveredItemId !== this.props.hoveredItemId) {
      this.tool.setPrevHoveredItemId(nextProps.hoveredItemId);
    }
    if (this.tool && nextProps.selectedItems !== this.props.selectedItems) {
      this.tool.onSelectionChanged(nextProps.selectedItems);
    }

    if (nextProps.isSelectModeActive && !this.props.isSelectModeActive) {
      this.activateTool();
    } else if (!nextProps.isSelectModeActive && this.props.isSelectModeActive) {
      this.deactivateTool();
    }
  }
  shouldComponentUpdate(nextProps) {
    return nextProps.isSelectModeActive !== this.props.isSelectModeActive;
  }
  componentWillUnmount() {
    if (this.tool) {
      this.deactivateTool();
    }
  }
  activateTool() {
    this.tool = new SelectTool(
      this.props.setHoveredItem,
      this.props.clearHoveredItem,
      this.props.setSelectedItems,
      this.props.clearSelectedItems,
      this.props.setCursor,
      this.props.onUpdateImage,
      this.props.switchToTextTool
    );
    this.tool.activate();
  }
  deactivateTool() {
    this.tool.deactivateTool();
    this.tool.remove();
    this.tool = null;
  }
  render() {
    return <SelectModeComponent isSelected={this.props.isSelectModeActive} onMouseDown={this.props.handleMouseDown} />;
  }
}

SelectMode.propTypes = {
  clearHoveredItem: PropTypes.func.isRequired,
  clearSelectedItems: PropTypes.func.isRequired,
  handleMouseDown: PropTypes.func.isRequired,
  hoveredItemId: PropTypes.number,
  isSelectModeActive: PropTypes.bool.isRequired,
  onUpdateImage: PropTypes.func.isRequired,
  selectedItems: PropTypes.arrayOf(PropTypes.instanceOf(paper.Item)),
  setCursor: PropTypes.func.isRequired,
  setHoveredItem: PropTypes.func.isRequired,
  setSelectedItems: PropTypes.func.isRequired,
  switchToTextTool: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  isSelectModeActive: state.scratchPaint.mode === Modes.SELECT,
  hoveredItemId: state.scratchPaint.hoveredItemId,
  selectedItems: state.scratchPaint.selectedItems
});
const mapDispatchToProps = (dispatch) => ({
  setHoveredItem: (hoveredItemId) => {
    dispatch(setHoveredItem(hoveredItemId));
  },
  clearHoveredItem: () => {
    dispatch(clearHoveredItem());
  },
  clearSelectedItems: () => {
    dispatch(clearSelectedItems());
  },
  setSelectedItems: () => {
    dispatch(setSelectedItems(getSelectedLeafItems(), false /* bitmapMode */));
  },
  setCursor: (cursorString) => {
    dispatch(setCursor(cursorString));
  },
  handleMouseDown: () => {
    dispatch(changeMode(Modes.SELECT));
  },
  switchToTextTool: () => {
    dispatch(changeMode(Modes.TEXT));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectMode);
